import React from 'react';
interface ShinyTextProps {
  text: string;
  speed?: number;
  className?: string;
}
export function ShinyText({
  text,
  speed = 5,
  className = ''
}: ShinyTextProps) {
  return <span className={`inline-block bg-clip-text text-transparent ${className}`} style={{
    backgroundImage: 'linear-gradient(120deg, rgba(255,255,255,0.5) 40%, rgba(255,255,255,1) 50%, rgba(255,255,255,0.5) 60%)',
    backgroundSize: '200% 100%',
    animation: `shiny-text ${speed}s linear infinite`
  }} data-id="element-250">
      {text}
    </span>;
}